import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import {
  NotificationTemplateModel,
  UpdateNotificationTemplate,
} from '../../models/notification-template.model';

/**
 * Admin CRUD for editable notification templates. Edit-only over the fixed,
 * code-referenced set exposed by the backend (`/api/admin/email-templates`).
 */
@Injectable({
  providedIn: 'root',
})
export class NotificationTemplateService {
  private readonly baseUrl = `${environment.apiUrl}/api/admin/email-templates`;

  constructor(private readonly http: HttpClient) {}

  getTemplates(): Observable<NotificationTemplateModel[]> {
    return this.http.get<NotificationTemplateModel[]>(this.baseUrl);
  }

  getTemplate(code: string): Observable<NotificationTemplateModel> {
    return this.http.get<NotificationTemplateModel>(`${this.baseUrl}/${code}`);
  }

  updateTemplate(
    code: string,
    data: UpdateNotificationTemplate
  ): Observable<NotificationTemplateModel> {
    return this.http.put<NotificationTemplateModel>(`${this.baseUrl}/${code}`, data);
  }

  /** Sends the (possibly unsaved) draft, filled with sample values, to the signed-in user. */
  sendTest(code: string, data: UpdateNotificationTemplate): Observable<{ sentTo: string }> {
    return this.http.post<{ sentTo: string }>(`${this.baseUrl}/${code}/test`, data);
  }
}
